import type { WCmsPhotoPageView } from '@zola/svc-web-api-ts-client';
import ApiService from '@zola-helpers/client/dist/es/http/api';

export const getGalleryPage = async (): Promise<WCmsPhotoPageView> =>
  ApiService.get('/web-api/v1/cms/page/photo');
